import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ServisniPaketyNd = {
	name: NAME,
	apiProvider,
	router,
};
